module.exports = __webpack_public_path__ + "img/je.4079f403.svg";